<template lang="pug">
#about_us
  alert-popup(:q="3")
  about-us-header(:aboutUsCommon="aboutUsCommon")
  .tabs_container
    nav.container.custom_container_extra_lg
      .row.text-center
        .tab_wrapper.flex_v
          media-img.golden_line_up.i_mt_3.i_mt_sm_2(:imgUrl="'golden_line_up'")
          .tabs.flex_h
            router-link.tab_(
              v-if="index != 5",
              v-for="(tab, index) in aboutUsCommon.Menu",
              :key="index",
              tag="a",
              :to="{ name: tab.pathName }"
            )
              tab(
                :key="index",
                :title="tab.MenuTitle",
                :img="tab.MenuIcon",
                :selected="$route.name == tab.pathName || $route.name.includes(tab.pathName)"
              )
            a.tab_(
              v-if="index == 5",
              v-for="(tab, index) in aboutUsCommon.Menu",
              href="/customize/Stewardship",
              target="_blank"
            )
              tab(:key="index", :title="tab.MenuTitle", :img="tab.MenuIcon")

          .tabs.tabs_sm.d-md-none.flex_h
            router-link.tab_(
              v-for="(tab, index) in aboutUsCommon.Menu",
              :key="index",
              v-if="index >= 3 && index != 5",
              tag="a",
              :to="{ name: tab.pathName }"
            )
              tab(
                :key="index",
                :title="tab.MenuTitle",
                :img="tab.MenuIcon",
                :selected="$route.name == tab.pathName || $route.name.includes(tab.pathName)"
              )
            a.tab_(
              v-for="(tab, index) in aboutUsCommon.Menu",
              :key="index",
              v-if="index >= 3 && index == 5",
              href="/customize/Stewardship",
              target="_blank"
            )
              tab(:key="index", :title="tab.MenuTitle", :img="tab.MenuIcon")
          media-img.line_bottom.d-md-none(:imgUrl="'golden_line_up'")
    transition(name="page", mode="out-in")
      router-view(:key="$route.path")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import aboutUsHeader from "@/components/common/Header";
import Tab from "@/components/about_us/Tab";
import MediaImg from "@/components/common/MediaImg";
import { getAboutUsCommon } from "@/json/about_us";
import AlertPopup from "@/components/common/AlertPopup";

export default {
  name: "AboutUs",
  components: {
    "custom-footer": CustomFooter,
    "about-us-header": aboutUsHeader,
    Tab,
    "media-img": MediaImg,
    AlertPopup,
  },
  data() {
    return {
      aboutUsCommon: {},
    };
  },
  watch: {},
  created() {
    this.getAboutUsCommon()
  },
  mounted() {},
  methods: {
    getAboutUsCommon() {
      getAboutUsCommon().then((response) => {
        this.aboutUsCommon = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/about_us";
</style>
